import React, { Fragment } from "react";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useParams } from "react-router-dom";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";

const RaiseElectricityBillForm = (props) => {
  const {distributorDetails} = props;
  const [canRaiseElectricityBillApi] = getApi('canRaiseElectricityBill');
  const params = useParams();

  const toggleCanRaiseElectricityBillState = async (event) => {
    try{
      let response = await canRaiseElectricityBillApi({id: params.id}).unwrap();
      distributorDetails.can_raise_electricity_bill = !distributorDetails.can_raise_electricity_bill;
      toast.success(response.message);
    }
    catch(error) {
      toast.error(error?.data?.message || 'Something went wrong !');
    }
  }

  return <Fragment>
    <div className="d-flex m-2 justify-content-between">
      <label htmlFor="can_raise_electricity_bill" className="pt-2 fw-bold">Can Raise Electricity Bill</label>
      <ToggleSwitch
        id="can_raise_electricity_bill"
        label_left="No"
        label_right ="Yes"
        onChange={(e) => toggleCanRaiseElectricityBillState(e)}
        checked={distributorDetails.can_raise_electricity_bill}
      />
    </div>
  </Fragment>
}

export default RaiseElectricityBillForm;
